/**
 * Socket.io event types for game communication
 */
/**
 * Error codes
 */
export var GameErrorCode;
(function (GameErrorCode) {
    GameErrorCode["NOT_HOST"] = "not_host";
    GameErrorCode["NOT_ENOUGH_PLAYERS"] = "not_enough_players";
    GameErrorCode["GAME_ALREADY_STARTED"] = "game_already_started";
    GameErrorCode["GAME_NOT_STARTED"] = "game_not_started";
    GameErrorCode["INVALID_PHASE"] = "invalid_phase";
    GameErrorCode["ALREADY_REFRESHED"] = "already_refreshed";
    GameErrorCode["INVALID_PROMPT_INDEX"] = "invalid_prompt_index";
    GameErrorCode["PROMPT_ALREADY_SELECTED"] = "prompt_already_selected";
    GameErrorCode["NOT_PRESENTER"] = "not_presenter";
    GameErrorCode["NOT_GUESSER"] = "not_guesser";
    GameErrorCode["CLUE_VALIDATION_FAILED"] = "clue_validation_failed";
    GameErrorCode["INVALID_FRAMEWORK"] = "invalid_framework";
})(GameErrorCode || (GameErrorCode = {}));
//# sourceMappingURL=gameEvents.js.map